import { CssBaseline, ThemeProvider } from "@mui/material";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import RTL from "components/RTL";
import useSettings from "hooks/useSettings";
import { useRoutes } from "react-router-dom";
import routes from "routes";
import { createCustomTheme } from "theme";
import { Toaster } from 'react-hot-toast';
import { useEffect } from "react";
import { getApplicationFaviconPath } from "config/constants";
import "./i18n";
import './globalStyles.css';

const App = () => {
  const content = useRoutes(routes());
  const { settings } = useSettings();
  const theme = createCustomTheme({
    theme: settings.theme,
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
  });

  useEffect(() => {
    const faviconPath = getApplicationFaviconPath(theme.palette.mode === "light");
    document.querySelectorAll("link[rel='icon'], link[rel='apple-touch-icon']").forEach((link) => {
      link.href = faviconPath;
    });
  }, [theme.palette.mode]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <RTL>
          <CssBaseline />
          {content}
          <Toaster />
        </RTL>
      </ThemeProvider>
    </StyledEngineProvider>    
  );
};

export default App;
